import React, {useEffect, useRef, useState} from 'react'
import {useLocation} from "react-router-dom";
import Select from 'react-select';
import FromFieldText from '../../../atoms/FromFieldText';
import './SingleAsset.css';
import './UploadImage.css';
import { getAllAssetsTag, getAssetsImages, getInvoices, getSTPI, getSuppliers,
    saveSingleImage, getAssetsImagesCount, getAllImagesByTag, getAllImagesByInvoice } from '../../../services/asset.service';
import * as CryptoJS from "crypto-js";

const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;

export default function UploadAssetImage() {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const elementRef = useRef();

    // ... (All state declarations remain the same)
    const [imgDesc, setImgDesc] = useState('');
    const [ErrImgDesc, setErrImgDesc] = useState(false);
    const [uploadassetimage, setUploadAssetImage] = useState([]);
    const [tag, setTag] = useState('');
    const [supplier, setSupplier] = useState('');
    const [invoice, setInvoice] = useState('');
    const [ErrTag, setErrTag] = useState(false);
    const [ErrInvoice, setErrInvoice] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [assetInfo, setAssetInfo] = useState({});
    const [allAssets, setAllAssetsData] = useState([]);
    const [suppliers, setSuppliersData] = useState([]);
    const [invoices, setInvoicesData] = useState([]);
    const [imgFile, setImgFile] = useState([]);
    const [imageCount, setImageCount] = useState(0);
    const [imagelist, setImageList] = useState([]);
    const [uploadfrontimage, setUploadFrontImage] = useState(null);
    const [ErrUploadFrontImage, setErrUploadFrontImage] = useState(false);
    const [ErrUploadMaxImage, setErrUploadMaxImage] = useState(false);
    const [uploadbackimage, setUploadBackImage] = useState(null);
    const [ErrUploadBackImage, setErrUploadBackImage] = useState(false);
    const [uploadtopimage, setUploadTopImage] = useState(null);
    const [ErrUploadTopImage, setErrUploadTopImage] = useState(false);
    const [uploadbottomimage, setUploadBottomImage] = useState(null);
    const [ErrUploadBottomImage, setErrUploadBottomImage] = useState(false);
    const [uploadleftimage, setUploadLeftImage] = useState(null);
    const [ErrUploadLeftImage, setErrUploadLeftImage] = useState(false);
    const [uploadrightimage, setUploadRightImage] = useState(null);
    const [ErrUploadRightImage, setErrUploadRightImage] = useState(false);
    const [uploadotherimage, setUploadOtherImage] = useState(null);
    const [ErrUploadOtherImage, setErrUploadOtherImage] = useState(false);

    const maxFiles = 7 - imageCount;
    const maxFileSize = 5 * 1024 * 1024;
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const remainingFiles = maxFiles - uploadassetimage.length;

    // ... (All useEffect and handler functions remain exactly the same)
    useEffect(() => {
        if (Tag !== '' && Tag !== null) {
            getAssetsImagesInfo(Tag);
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
        getAllAssetsTag(oData).then(res => {
            if (res?.data?.data?.length) setAllAssetsData(res.data.data);
        });
        getSuppliers(oData).then(res => {
            if (res?.data?.data?.length) setSuppliersData(res.data.data);
        });
    }, []);

    const getAssetsImagesInfo = function (Tag) {
        try {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {'tag': Tag},
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = {'token': EncryptData}
            getAssetsImages(oData1).then(function (res) {
                if (res?.data?.data) {}
            });
        } catch (err) {}
    }

    // All image upload handlers remain the same
    const handleUploadFrontImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadFrontImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadFrontImage('File size must be less than 5MB.');
                return;
            }
            if (files.length > maxFiles) {
                setErrUploadMaxImage(`You can only upload a maximum of ${maxFiles} files.`);
                return;
            }
            setImgFile((prev) => [...prev, { type: 'front', file: files[0] }]);
            setUploadFrontImage(files[0]);
        }
    }

    // Similar handlers for other views (back, top, bottom, left, right, other)
    const handleUploadBackImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadBackImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadBackImage('File size must be less than 5MB.');
                return;
            }
            setImgFile((prev) => [...prev, { type: 'back', file: files[0] }]);
        }
    }

    const handleUploadTopImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadTopImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadTopImage('File size must be less than 5MB.');
                return;
            }
            setImgFile((prev) => [...prev, { type: 'top', file: files[0] }]);
        }
    }

    const handleUploadBottomImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadBottomImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadBottomImage('File size must be less than 5MB.');
                return;
            }
            setImgFile((prev) => [...prev, { type: 'bottom', file: files[0] }]);
        }
    }

    const handleUploadLeftImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadLeftImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadLeftImage('File size must be less than 5MB.');
                return;
            }
            setImgFile((prev) => [...prev, { type: 'left', file: files[0] }]);
        }
    }

    const handleUploadRightImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadRightImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadRightImage('File size must be less than 5MB.');
                return;
            }
            setImgFile((prev) => [...prev, { type: 'right', file: files[0] }]);
        }
    }

    const handleUploadOtherImage = (e) => {
        const files = e.target.files;
        if(files[0]){
            if (!allowedTypes.includes(files[0].type)) {
                setErrUploadOtherImage('Only JPG, JPEG, and PNG files are allowed.');
                return;
            }
            if (files[0].size > maxFileSize) {
                setErrUploadOtherImage('File size must be less than 5MB.');
                return;
            }
            setImgFile((prev) => [...prev, { type: 'other', file: files[0] }]);
        }
    }

    const optionList = allAssets && allAssets.length > 0 
        ? allAssets.map((option) => ({value: option.tag, label: option.tag}))
        : [{value: "", label: "No Data"}];

    const [selectedOptions, setSelectedOptions] = useState();

    function handleSelect(data) {
        setSelectedOptions(data);
        setTag(data.value);
        fetchImageCount(data.value);
    }

    const fetchImageCount = (selectedTag) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': selectedTag},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = {'token': EncryptData}
        getAssetsImagesCount(oData3).then(res => {
            const imageCount = res.data.data[0]?.count;
            setImageCount(imageCount);
        }).catch(error => {
            console.error('Error fetching image count:', error);
        });
    };

    const fetchInvoiceCount = (invoice_no) => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': tag, 'invoice_no': invoice_no, 'supplier_name': supplier},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = {'token': EncryptData}
        getAssetsImagesCount(oData3).then(res => {
            const imageCount = res.data.data[0]?.count;
            setImageCount(imageCount);
        }).catch(error => {
            console.error('Error fetching image count:', error);
        });
    };

    const supplierList = suppliers && suppliers.length > 0
        ? suppliers.map((option) => ({value: option.supplier_name, label: option.supplier_name}))
        : [{value: "", label: "No Data"}];

    const [supplierOptions, setSupplierOptions] = useState();

    function handleSupplier(data) {
        setSupplierOptions(data);
        setSupplier(data.value);
        var oParam1 = {'supplier_name': data.value}
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': oParam1,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData2 = {'token': EncryptData}
        getInvoices(oData2).then(res => {
            if (res?.data?.data?.length) setInvoicesData(res.data.data);
        });
    }

    const invoiceList = invoices && invoices.length > 0
        ? invoices.map((option) => ({value: option.invoice_no, label: option.invoice_no}))
        : [{value: "", label: "No Data"}];

    const [invoiceOptions, setInvoiceOptions] = useState();

    function handleInvoice(data) {
        setInvoiceOptions(data);
        setInvoice(data.value);
        fetchInvoiceCount(data.value);
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': tag, 'invoice_no': data.value, 'supplier_name': supplier},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = {'token': EncryptData}
        getAllImagesByInvoice(oData3).then(function (res) {
            if (res.status === 200) {
                var data = res?.data?.data;
                if (data.length) {
                    setImageList(data);
                }
            }
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;

        if (tag == "" && invoice == '') {
            setErrInvoice('Tag OR Invoice is required');
            valid_Name = false;
        } else {
            setErrInvoice('');
        }

        if (!TEXT_REGEX.test(imgDesc)) {
            setErrImgDesc('Image description is required');
            valid_Name = false;
        } else {
            setErrImgDesc('');
        }

        if(imagelist.filter(option => option.asset_dimension === "front").length == 0){
            if (uploadfrontimage == null || uploadfrontimage == '') {
                setErrUploadFrontImage('Upload asset image is required');
                valid_Name = false;
            } else {
                setErrUploadFrontImage('');
            }
        } else {
            setErrUploadFrontImage('');
        }

        if(imgFile.length == 0){
            setErrUploadMaxImage('Image is required');
            valid_Name = false;
        } else {
            setErrUploadMaxImage('');
        }

        if (valid_Name) {
            saveData();
        } else {
            return false;
        }
    }

    const resetAssetInfo = function () {
        setTag('');
        setSelectedOptions('');
        setImgDesc('');
        setUploadFrontImage('');
        setUploadBackImage('');
        setUploadTopImage('');
        setUploadBottomImage('');
        setUploadLeftImage('');
        setUploadRightImage('');
        setUploadOtherImage('');
    }

    const getTagInfo = function () {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tag': tag},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData3 = {'token': EncryptData}
        getSTPI(oData3).then(function (res) {
            var aInfo = {};
            if (res?.data?.data?.assetInfo) {
                setErrMsg('');
                aInfo = res.data.data.assetInfo;
                setAssetInfo(aInfo);
                setTag(aInfo.tag);
            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }
        });
        getAllImagesByTag(oData3).then(function (res) {
            if (res.status === 200) {
                var data = res?.data?.data;
                if (data.length) {
                    setImageList(data);
                }
            }
        });
    }

    const saveData = function () {
        try {
            const formData = new FormData();
            var types = [];
            imgFile.forEach(({ file, type }, index) => {
                formData.append("images[]", file);
                types.push(type);
            });
            const jsonData = {
                tag,
                invoice_no: invoice,
                supplier_name: supplier,
                asset_image_desc: imgDesc,
                upload_dir: "images",
                created_by: sessionStorage.getItem("LoggedInUserId"),
                authToken: sessionStorage.getItem("LoggedInToken"),
                companyshortname: sessionStorage.getItem("LoggedInCompanyShortName"),
                users: {
                    'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                    'department_id': sessionStorage.getItem('LoggedInDepartmentId'),
                    'division_id': sessionStorage.getItem('LoggedInDivisionId'),
                }
            };
            const objAudit = {
                'audit_module': 'Upload Images',
                'audit_method': 'created',
                'audit_tag': tag,
                'old_values': '',
                'new_values': JSON.stringify(jsonData)
            };
            jsonData.audit_params = objAudit;
            jsonData.dimension = types;
            const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(jsonData), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            formData.append("metadata", encryptedData);

            saveSingleImage(formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(function (res) {
                if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    setDisabled(true);
                    setErrMsg(false);
                    setErrTag('');
                    resetAssetInfo();
                }
            });
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('Username Taken');
            } else {
                setErrMsg('Insert/Update Failed');
            }
        }
    }

    // Custom styles for react-select
    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '42px',
            borderColor: '#e2e6ef',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#0e8aca'
            }
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#0e8aca' : state.isFocused ? '#eef7fd' : 'white',
            color: state.isSelected ? 'white' : '#333',
            cursor: 'pointer'
        })
    };

    const renderImageUploadItem = (label, viewType, handler, uploadedFile, errorMsg, badgeClass) => {
        const isUploaded = imagelist.filter(option => option.asset_dimension === viewType).length > 0;
        return (
            <div className={`upload-image-upload-item ${isUploaded ? 'uploaded disabled' : ''}`}>
                <div className={`upload-image-upload-label ${isUploaded ? 'uploaded' : ''}`}>
                    <i className={isUploaded ? "bi bi-check-circle-fill" : "bi bi-image-fill"}/>
                    {label}
                    <span className={`upload-image-view-badge upload-image-view-badge-${viewType}`}>
                        {viewType}
                    </span>
                </div>
                <input
                    type="file"
                    name="images"
                    onChange={handler}
                    disabled={isUploaded}
                    className="upload-image-file-input"
                    accept="image/jpeg,image/jpg,image/png"
                />
                {errorMsg && (
                    <span className="upload-image-error-message">
                        <i className="bi bi-exclamation-circle"/> {errorMsg}
                    </span>
                )}
                {isUploaded && (
                    <span className="upload-image-upload-badge">
                        <i className="bi bi-check-circle"/> Already Uploaded
                    </span>
                )}
            </div>
        );
    };

    return (
        <div className="al-page">
            {/* Header */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-cloud-upload-fill"/>
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Upload Asset Images</h5>
                        <p className="al-page-subtitle">Upload and manage asset images from multiple angles</p>
                    </div>
                </div>
            </div>
            
            {/* Alerts */}
            {success && (
                <div className="upload-image-alert upload-image-alert-success">
                    <i className="bi bi-check-circle-fill"></i>
                    <span>{success}</span>
                </div>
            )}
            {errMsg && (
                <div className="upload-image-alert upload-image-alert-danger">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                    <span>{errMsg}</span>
                </div>
            )}

            {/* Search Section */}
            {!(Tag !== '' && Tag !== null) && (
                <div className="upload-image-card" id="search-section">
                    <div className="upload-image-card-header">
                        <i className="bi bi-search"/>
                        <h6>SEARCH ASSET</h6>
                    </div>

                    <div className="upload-image-search-row">
                        <div className="upload-image-search-label">
                            <i className="bi bi-tag-fill"/>
                            <label>Search by TAG</label>
                        </div>
                        <div className="upload-image-search-grid">
                            <div className="upload-image-select-container">
                                <Select
                                    options={optionList}
                                    placeholder="Select asset TAG..."
                                    value={selectedOptions}
                                    onChange={handleSelect}
                                    styles={selectStyles}
                                />
                                {ErrTag && (
                                    <span className="upload-image-error-message">
                                        <i className="bi bi-exclamation-circle"/> {ErrTag}
                                    </span>
                                )}
                            </div>
                            <div className="upload-image-search-actions">
                                <button onClick={getTagInfo} className="upload-image-btn upload-image-btn-primary">
                                    <i className="bi bi-search"/> Search
                                </button>
                                <a href="/upload-image-new">
                                    <button className="upload-image-btn upload-image-btn-outline">
                                        <i className="bi bi-arrow-clockwise"/> Reset
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="upload-image-divider"><span>OR</span></div>

                    <div className="upload-image-form-grid upload-image-form-grid-2col">
                        <div className="upload-image-form-group">
                            <div className="upload-image-search-label">
                                <i className="bi bi-building"/>
                                <label>Search by Supplier</label>
                            </div>
                            <div className="upload-image-select-container">
                                <Select
                                    options={supplierList}
                                    placeholder="Select supplier..."
                                    value={supplierOptions}
                                    onChange={handleSupplier}
                                    styles={selectStyles}
                                />
                            </div>
                        </div>

                        <div className="upload-image-form-group">
                            <div className="upload-image-search-label">
                                <i className="bi bi-receipt"/>
                                <label>Search by Invoice No.</label>
                            </div>
                            <div className="upload-image-select-container">
                                <Select
                                    options={invoiceList}
                                    placeholder="Select invoice..."
                                    value={invoiceOptions}
                                    onChange={handleInvoice}
                                    styles={selectStyles}
                                />
                                {ErrInvoice && (
                                    <span className="upload-image-error-message">
                                        <i className="bi bi-exclamation-circle"/> {ErrInvoice}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Upload Form */}
            <div className="upload-image-card" id="image-upload-form">
                <div className="upload-image-card-header">
                    <i className="bi bi-images"/>
                    <h6>UPLOAD IMAGES</h6>
                </div>

                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    {/* Asset TAG */}
                    <div className="upload-image-form-group">
                        <label className="upload-image-form-label">Asset TAG</label>
                        <input
                            type="text"
                            value={tag || ''}
                            readOnly
                            className="upload-image-input"
                        />
                    </div>

                    {/* Image Description */}
                    <div className="upload-image-form-group">
                        <label className="upload-image-form-label">
                            Image Description <span className="upload-image-required">*</span>
                        </label>
                        <input
                            type="text"
                            placeholder="Enter image description..."
                            value={imgDesc}
                            onChange={(e) => setImgDesc(e.target.value)}
                            className={`upload-image-input ${ErrImgDesc ? 'error' : ''}`}
                        />
                        {ErrImgDesc && (
                            <span className="upload-image-error-message">
                                <i className="bi bi-exclamation-circle"/> {ErrImgDesc}
                            </span>
                        )}
                    </div>

                    {/* Info Section */}
                    <div className="upload-image-info-section">
                        <div className="upload-image-info-content">
                            <i className="bi bi-info-circle upload-image-info-icon"/>
                            <div className="upload-image-info-text">
                                <p className="upload-image-info-title">Upload Guidelines</p>
                                <p className="upload-image-info-description">
                                    JPG, JPEG, PNG only • Max 5MB per file • {remainingFiles} slots remaining
                                </p>
                            </div>
                            <div className="upload-image-info-count">{imageCount}/7</div>
                        </div>
                    </div>

                    {/* Image Upload Grid */}
                    <div className="upload-image-grid">
                        {renderImageUploadItem("Front View", "front", handleUploadFrontImage, uploadfrontimage, ErrUploadFrontImage, "front")}
                        {renderImageUploadItem("Back View", "back", handleUploadBackImage, uploadbackimage, ErrUploadBackImage, "back")}
                        {renderImageUploadItem("Left View", "left", handleUploadLeftImage, uploadleftimage, ErrUploadLeftImage, "left")}
                        {renderImageUploadItem("Right View", "right", handleUploadRightImage, uploadrightimage, ErrUploadRightImage, "right")}
                        {renderImageUploadItem("Top View", "top", handleUploadTopImage, uploadtopimage, ErrUploadTopImage, "top")}
                        {renderImageUploadItem("Bottom View", "bottom", handleUploadBottomImage, uploadbottomimage, ErrUploadBottomImage, "bottom")}
                        {renderImageUploadItem("Other View", "other", handleUploadOtherImage, uploadotherimage, ErrUploadOtherImage, "other")}
                    </div>

                    {ErrUploadMaxImage && (
                        <div className="upload-image-alert upload-image-alert-danger" style={{marginTop: '20px'}}>
                            <i className="bi bi-exclamation-triangle-fill"></i>
                            <span>{ErrUploadMaxImage}</span>
                        </div>
                    )}

                    {/* Action Buttons */}
                    <div className="upload-image-actions">
                        {(Tag !== '' && Tag !== null) ? (
                            <>
                                <button type="submit" className="upload-image-btn upload-image-btn-primary upload-image-btn-lg">
                                    <i className="bi bi-check-circle"/> Update
                                </button>
                                <a href={'/asset-details?tag=' + Tag}>
                                    <button type="button" className="upload-image-btn upload-image-btn-secondary upload-image-btn-lg">
                                        <i className="bi bi-x-circle"/> Cancel
                                    </button>
                                </a>
                            </>
                        ) : (
                            <button
                                type="submit"
                                disabled={disabled}
                                className="upload-image-btn upload-image-btn-primary upload-image-btn-xl"
                            >
                                <i className="bi bi-upload"/> UPLOAD IMAGES
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}